import React from "react";
import { siigsolLegends } from "./legendData";

export default function SIIGSOLLegend({ layer }) {
  const legendData = siigsolLegends[layer];
  
  // DEBUG: Afficher dans la console ce qui est chargé
  console.log("=== SIIGSOL DEBUG ===");
  console.log("Layer:", layer);
  console.log("Legend Data:", legendData);
  
  if (!legendData) return null;

  // Supporte l'ancienne structure (array) et la nouvelle (object avec title et items)
  const items = Array.isArray(legendData) ? legendData : legendData.items;
  const title = legendData.title || "Légende SIIGSOL";
  
  console.log("Title:", title);
  console.log("Items:", items);

  return (
    <div
      className="legend-panel"
      style={{
        padding: "0.7em",
        background: "#fff",
        borderRadius: "8px",
        width: "200px",
        minWidth: "180px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        marginTop: "1em",
        wordBreak: "break-word"
      }}
    >
      <h5 style={{ 
        color: "#37744b", 
        fontSize: "0.95em", 
        marginBottom: "0.8em",
        fontWeight: "bold"
      }}>
        {title}
      </h5>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {items.map((item, idx) => (
          <li
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.7em"
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "20px",
                height: "14px",
                background: item.color,
                border: "1px solid #232b21",
                borderRadius: "3px",
                marginRight: "0.6em",
                flexShrink: 0
              }}
            ></span>
            <span style={{ color: "#232b21", fontSize: "0.75em", lineHeight: "1.3" }}>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}